import * as React from "react";

function SvgCoffee(props, { color = "#00DFED", width = 20, height = 20 }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#svg_coffee_icon)">
        <path
          d="M15.0013 6.66536H15.8346C16.7187 6.66536 17.5665 7.01655 18.1917 7.64167C18.8168 8.2668 19.168 9.11464 19.168 9.9987C19.168 10.8828 18.8168 11.7306 18.1917 12.3557C17.5665 12.9808 16.7187 13.332 15.8346 13.332H15.0013M15.0013 6.66536H1.66797V14.1654C1.66797 15.0494 2.01916 15.8973 2.64428 16.5224C3.2694 17.1475 4.11725 17.4987 5.0013 17.4987H11.668C12.552 17.4987 13.3999 17.1475 14.025 16.5224C14.6501 15.8973 15.0013 15.0494 15.0013 14.1654V6.66536ZM5.0013 0.832031V3.33203M8.33463 0.832031V3.33203M11.668 0.832031V3.33203"
          stroke={props.color || color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="svg_coffee_icon">
          <rect width={width} height={height} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgCoffee;
